import { black, lightGrey } from '../../../styles/const/colors'
import { formatReportNumber } from '../../formatters'

const getReusableGraphOptions = ({
  format,
  graphColor = '',
  theme = {},
  tooltipCallbackOptions = {},
  currencySymbol
}) => ({
  responsive: true,
  maintainAspectRatio: false,
  hover: {
    mode: 'index',
    intersect: false
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      display: true
    },
    y: {
      grid: {
        color: lightGrey,
        drawBorder: false,
        display: false
      },
      ticks: {
        padding: 0,
        textAlign: 'left',
        maxTicksLimit: 5,
        maxRotation: 0,
        minRotation: 0,
        font: {
          size: 14,
          weight: 300
        }
      },
      beginAtZero: true,
      padding: 20
    }
  },
  elements: {
    point: {
      // this -1 radius is needed to fix behaviour when pointer was under axis line
      radius: -1,
      borderWidth: 3,
      hoverRadius: 5,
      hoverBorderColor: graphColor || theme.brandPrimary,
      hoverBackgroundColor: '#ffffff',
      hoverBorderWidth: 3
    }
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      display: false,
      callbacks: {
        label: tooltipItem => formatReportNumber({ value: tooltipItem.raw, format, currency: currencySymbol }),
        ...tooltipCallbackOptions
      },

      mode: 'index',
      intersect: false,
      displayColors: false,
      backgroundColor: '#ffffff',
      titleColor: graphColor || theme.brandPrimary,
      titleFont: {
        weight: 400,
        size: 14
      },
      titleMarginBottom: 10,
      bodyFont: {
        weight: 400,
        size: 14
      },
      bodyColor: black,
      bodySpacing: 6,
      footerColor: black,
      footerFont: {
        weight: 400,
        size: 14
      },
      footerMarginTop: 6,
      footerSpacing: 6,
      borderWidth: 1,
      borderColor: lightGrey,
      cornerRadius: 4,
      padding: {
        left: 15,
        right: 15,
        top: 12,
        bottom: 12
      }
    }
  }
})

export default getReusableGraphOptions
